import {createSlice, PayloadAction} from "@reduxjs/toolkit";


interface DonationAmountScreenState {
  show: boolean,
  activityId?: number,
  campaignShort?: string,
}

const initialState: DonationAmountScreenState = {
  show: false,
};

const donationAmountScreenSlice = createSlice({
  name: 'donationAmountScreen',
  initialState,
  reducers: {
    updateShowDonationAmountScreen: (state, action: PayloadAction<DonationAmountScreenState>) => {
      state.show = action.payload.show
      state.activityId = action.payload.activityId
      state.campaignShort = action.payload.campaignShort
    }
  }
})

export const { updateShowDonationAmountScreen } = donationAmountScreenSlice.actions;

export default donationAmountScreenSlice.reducer;
